import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Seo from "@/components/Seo";
import ContactBar from "@/components/ContactBar";
import ContactForm from "@/components/ContactForm";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import BookCallButton from "@/components/BookCall";
import Reveal from "@/components/Reveal";
import { sz, txt, useContent } from "@/content/ContentContext";
import { buildBlogFaqs, resolveFaqs } from "@/content/faqData";
import { PAGE_META, breadcrumbSchema } from "@/content/seoData";

const Blog = () => {
  const c = useContent();
  const b = c.blog;

  return (
    <div className="App">
      <Seo
        title={PAGE_META.blog.title}
        description={PAGE_META.blog.description}
        path="/blog"
        schemas={[
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Blog", path: "/blog" },
          ]),
        ]}
      />
      <Header />
      <main>
        <section className="svcpage-hero">
          <Reveal className="svcpage-hero-inner" y={18}>
            <h1 className="svcpage-title" style={sz(b.titleStart)} data-testid="page-title">
              {txt(b.titleStart)}{" "}
              <span className="text-green" style={sz(b.titleAccent)}>{txt(b.titleAccent)}</span>
            </h1>
            <p className="svcpage-intro" style={sz(b.intro)}>{txt(b.intro)}</p>
          </Reveal>
        </section>

        <section className="blog-grid" data-testid="blog-grid">
          {b.posts.map((postContent, index) => {
            const slug = postContent.slug || `post-${index + 1}`;
            return (
              <Reveal
                as="article"
                key={slug}
                className="blog-card"
                data-testid={`blog-card-${slug}`}
                delay={(index % 2) * 0.12}
                y={26}
              >
                <div className="blog-meta">
                  <span style={sz(postContent.date)}>{txt(postContent.date)}</span>
                </div>
                <h2 className="blog-card-title" style={sz(postContent.title)}>{txt(postContent.title)}</h2>
                <p className="blog-excerpt" style={sz(postContent.excerpt)}>{txt(postContent.excerpt)}</p>
                <Link
                  to={`/blog/${slug}`}
                  className="svc-link"
                  style={sz(b.readMoreLabel)}
                  data-testid={`read-more-${slug}`}
                >
                  {txt(b.readMoreLabel)}
                </Link>
              </Reveal>
            );
          })}
        </section>

        <Reveal as="section" className="cta-banner" y={20}>
          <div className="cta-banner-text">
            <h3 style={sz(b.banner.heading)}>{txt(b.banner.heading)}</h3>
            <p style={sz(b.banner.text)}>{txt(b.banner.text)}</p>
          </div>
          <div className="cta-banner-actions">
            <BookCallButton
              className="btn-outline-light"
              testId="blog-banner-cta"
            />
            <a
              href="#message"
              className="alt-contact-link on-dark"
              style={sz(c.global.altContactLabel)}
              data-testid="blog-banner-alt-contact"
            >
              {txt(c.global.altContactLabel)}
            </a>
          </div>
        </Reveal>
      </main>
      <FAQSection items={resolveFaqs(c, "blog", buildBlogFaqs(c))} />
      <ContactForm />
      <ContactBar />
      <Footer />
    </div>
  );
};

export default Blog;
